<script setup>
const props = defineProps({
  initExpanded: { type: Boolean, default: false },
  isExpandable: { type: Boolean, default: true },
  title: { type: String, required: true },
  contents: { type: String },
  detailsClass: { type: String, default: '' },
})
const isInteracted = ref(false)
const isUserExpanded = ref(false)
const appConfig = useAppConfig()

const isExpanded = computed(() => {
  if (!isInteracted.value) {
    return props.initExpanded
  }
  else {
    return isUserExpanded.value
  }
})

const processedContents = computed(() => wrapTablesForScroll(normalizeHeadingLevels(enhanceCmsIframes(props.contents))))

function toggleExpansion() {
  isUserExpanded.value = !isExpanded.value
  isInteracted.value = true
}
</script>

<template>
  <button
    v-if="props.isExpandable"
    class="flex justify-between items-center w-full text-left cursor-pointer"
    :aria-label="`${isExpanded ? 'Collapse' : 'Expand'} ${props.title}`"
    @click="toggleExpansion"
  >
    <span class="font-bold text-med-navy text-2xl">
      {{ props.title }}
    </span>

    <UIcon
      :name="appConfig.ui.icons.chevronDown"
      class="relative size-10 shrink-0 transition duration-200 text-med-navy"
      :class="isExpanded ? 'rotate-180' : ''"
    />
  </button>

  <div
    v-else
    class="flex justify-between items-center"
  >
    <span class="font-bold text-med-navy text-2xl">
      {{ props.title }}
    </span>
  </div>
  <div v-show="isExpanded">
    <div
      class="product-details px-2 pt-4 text-med-navy"
      :class="props.detailsClass"
      v-html="processedContents"
    />
    <slot />
  </div>
</template>
